import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class StyleCriteria extends BasicCriteria {
owner: string;
visionCode: string;
visionCodeList: string[];
}

